import { render, staticRenderFns } from "./CenarioTitulo.vue?vue&type=template&id=94089b68&scoped=true&"
import script from "./CenarioTitulo.vue?vue&type=script&lang=js&"
export * from "./CenarioTitulo.vue?vue&type=script&lang=js&"
import style0 from "./CenarioTitulo.vue?vue&type=style&index=0&id=94089b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94089b68",
  null
  
)

export default component.exports